module.exports = __webpack_public_path__ + "static/media/purpose4.d875842e.svg";